import {SEND_PHONE_NUMBER_ERROR} from "../../reducers/signinReducer";

export const submitPhoneError = (authCode, error) =>{

    return {
        type: SEND_PHONE_NUMBER_ERROR,
        payload: {authCode, error}
    }
}